
let accessToken: string | null = localStorage.getItem('token') || null
let refreshToken: string | null = localStorage.getItem('refreshToken') || null

export const authStore = {
  getAccessToken: () => accessToken,
  getRefreshToken: () => refreshToken,

  setTokens: (access: string, refresh: string) => {
    accessToken = access
    refreshToken = refresh
    localStorage.setItem('token', access)
    localStorage.setItem('refreshToken', refresh)
  },

  clear: () => {
    accessToken = null
    refreshToken = null
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
  },
  setUser: (user: any) => {
    localStorage.setItem('user', JSON.stringify(user))
  },
    getUser: () => {
        const user = localStorage.getItem('user')
        return user ? JSON.parse(user) : null
    },
}
